import { AxiosInstance, AxiosRequestConfig } from 'axios';

import { OfflineOutlet, OutletOption } from './models/outlet';
const ENDPOINT = 'offline/';

// eslint-disable-next-line import/no-anonymous-default-export
export default (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  getEquipments: (last_update?: string) =>
    instance.get<ApiResponse<any>>(
      ENDPOINT +
        'equipments/' +
        (last_update ? `?last_update=${last_update}` : ''),
      config
    ),
  getGuides: () => instance.get<ApiResponse<any>>(ENDPOINT + 'guides/', config),
  getService: (last_update?: string) =>
    instance.get<ApiResponse<Paginated<'data', any>>>(
      ENDPOINT +
        'service/' +
        (last_update ? `?last_update=${last_update}` : ''),
      config
    ),
  getStands: (last_update?: string) =>
    instance.get<ApiResponse<Paginated<'data', any>>>(
      ENDPOINT +
        'stands/' +
        (last_update ? `?last_update=${last_update}` : ''),
      config
    ),
  getStandsDmp: (last_update?: string) =>
    instance.get<ApiResponse<Paginated<'data', any>>>(
      ENDPOINT +
        'stands_dmp/' +
        (last_update ? `?last_update=${last_update}` : ''),
      config
    ),
  getOutlets: () =>
    instance.get<ApiResponse<Paginated<'data', OfflineOutlet>>>(
      ENDPOINT + 'outlets/',
      config
    ),
  getOutletsList: () =>
    instance.get<ApiResponse<(OutletOption & { outlet: EntityBase })[]>>(
      ENDPOINT + 'outlet/get/',
      config
    ),
  addOutlet: (outletId: string) =>
    instance.post<ApiResponse<any>>(
      ENDPOINT + 'outlet/add/',
      { outlet_id: outletId },
      config
    ),
  removeOutlet: (outletId: string) =>
    instance.delete<ApiResponse<any>>(
      ENDPOINT + `outlet/delete/${outletId}/`,
      config
    ),
});
